module.exports = "/_next/static/images/Embed-937e0550b7117314fa802d88917a55e1.webp";